module.exports = __webpack_public_path__ + "static/media/img2.05231539.jpg";